import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";

var GoogleIcon = function GoogleIcon() {
  return _jsxs("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [_jsx("path", {
      d: "M12 5.25333C14.0656 5.25333 15.4589 6.14556 16.2533 6.89111L19.3578 3.86C17.4511 2.08778 14.97 1 12 1C7.69779 1 3.98223 3.46889 2.17334 7.06222L5.73001 9.82445C6.62223 7.17222 9.09112 5.25333 12 5.25333Z",
      fill: "#EA4335"
    }), _jsx("path", {
      d: "M22.56 12.2445C22.56 11.3401 22.4867 10.6801 22.3278 9.99561H12V14.0778H18.0622C17.94 15.0923 17.28 16.6201 15.8133 17.6467L19.2844 20.3356C21.3622 18.4167 22.56 15.5934 22.56 12.2445Z",
      fill: "#4285F4"
    }), _jsx("path", {
      d: "M5.74222 14.1756C5.51 13.4911 5.37556 12.7578 5.37556 12C5.37556 11.2423 5.51 10.5089 5.73 9.82448L2.17333 7.06226C1.42778 8.55337 1 10.2278 1 12C1 13.7723 1.42778 15.4467 2.17333 16.9378L5.74222 14.1756Z",
      fill: "#FBBC05"
    }), _jsx("path", {
      d: "M12 23C14.97 23 17.4633 22.0222 19.2844 20.3355L15.8133 17.6466C14.8844 18.2944 13.6378 18.7466 12 18.7466C9.0911 18.7466 6.62221 16.8278 5.74221 14.1755L2.18555 16.9378C3.99444 20.5311 7.69777 23 12 23Z",
      fill: "#34A853"
    })]
  }));
};

export default GoogleIcon;